import React from "react";
import { User } from "lucide-react";

const Profile = () => {
  return (
    <div>
      <div className="pt-1 h-20 border-b px-3 py-2 border-[#222731] flex flex-col justify-between">
        <div className="flex gap-2 flex-col items-center mt-1">
          <div className="flex ">
            <p className="text-xl text-[#222731] font-bold ">Memo User</p>
          </div>
        </div>
        <p className="text-xs mb-1 text-[#222731] text-center">Admin Account</p>
      </div>
    </div>
  );
};

export default Profile;
